import { Inject } from '@angular/core';
import templateSource from './view.html';
              import { Component } from '@angular/core';

import Wiz from 'src/wiz';
let wiz = new Wiz('/wiz').app('portal.monitoring.admin.machine');
import { OnInit, OnDestroy } from '@angular/core';
import { Service } from "src/libs/portal/season/service";
import { Router, ActivatedRoute } from '@angular/router';
import { Subscription } from 'rxjs';

@Component({
    selector: 'wiz-portal-monitoring-admin-machine',
template: templateSource || '',
    styles: [`

/* file: /mnt/data/wiz/project/main/build/src/app/portal.monitoring.admin.machine/view.scss */
/* src/app/portal.monitoring.admin.machine/view.scss: no such file or directory */`],
})
export class PortalMonitoringAdminMachineComponent implements OnInit, OnDestroy {

    public map: any = {};
    public math = Math;

    public list: any[] = [];
    public machines: any[] = [];
    public loading: boolean = false;

    public search: any = {
        machine_id: '',
        line: '',
        grade: '',
        page: 1
    };

    public facet: any = {};

    public page = 1;
    public lastPage = 1;

    private routeSub: Subscription;

    constructor(@Inject( Service)         public service: Service,@Inject( Router)         private router: Router,@Inject( ActivatedRoute    )         private route: ActivatedRoute    ) { }

    async ngOnInit() {

        await this.service.init();

        this.map.grade = '왕란,특란,대란,중란,소란,경란,파란,혈란,오란,등외'.split(',');

        await this.loadMachines();

        this.routeSub = this.route.queryParams.subscribe(async params => {

            this.search = {
                machine_id: '',
                line: '',
                grade: '',
                page: 1,
                ...params
            };

            this.page = Number(this.search.page) || 1;

            await this.load();
            await this.service.render();
        });
    }

    ngOnDestroy() {
        if (this.routeSub) this.routeSub.unsubscribe();
    }

    private async loadMachines() {

        const res = await wiz.call('machines');
        this.machines = res?.data || [];

        for (const machine of this.machines) {
            try { machine.machine_condition = JSON.parse(machine.machine_condition); } catch (e: any) { }
            try { machine.tray = JSON.parse(machine.tray); } catch (e: any) { }
        }
    }

    private async load() {
        this.loading = true;
        await this.service.render();

        const pd: any = {};
        Object.keys(this.search).forEach(key => {
            if (this.search[key] !== '' && this.search[key] !== undefined) {
                pd[key] = this.search[key];
            }
        });

        const res = await wiz.call('search', pd);

        if (!res || res.code !== 200) {
            this.list = [];
            this.lastPage = 1;
            this.loading = false;
            await this.service.render();
            return;
        }

        this.list = res.data.list || [];
        this.lastPage = res.data.lastpage || 1;
        this.loading = false;

        await this.service.render();
    }

    public goPage(page: number) {

        this.search.page = page;

        const queryParams: any = {};
        Object.keys(this.search).forEach(key => {
            if (this.search[key] !== '' && this.search[key] !== undefined) {
                queryParams[key] = this.search[key];
            }
        });

        this.router.navigate(
            ['/admin/monitoring/machine'],
            { queryParams }
        );
    }

    public searchEvent() {

        const queryParams: any = {
            machine_id: this.search.machine_id || null,
            line: this.search.line || null,
            grade: this.search.grade || null,
            page: 1
        };

        this.router.navigate(
            ['/admin/monitoring/machine'],
            { queryParams }
        );
    }

    public onPageChange = (page: number) => {
        this.goPage(page);
    }
}

export default PortalMonitoringAdminMachineComponent;